import { UserModel } from './../shared/models/user-info.model';
import { LoginModel } from './../security/security/login-and-register/login.model';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr';
import { LoadingSpinnerService } from './../shared/services/loading-spinner.service';
import { Http, Response } from '@angular/http';
import { JwtHelper } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import { AppSettings } from 'app/shared/app-settings';
import 'rxjs/add/operator/catch';


export const APP_TOKEN_NAME = 'online_app_auth_token';

@Injectable()
export class AuthService {

  constructor(
    private http: Http,
    public loader: LoadingSpinnerService,
    public toastr: ToastsManager) {
  }

  private jwtHelper: JwtHelper = new JwtHelper();

  private decodedJwt: any;

  public getToken(): string {
    return localStorage.getItem(APP_TOKEN_NAME) || sessionStorage.getItem(APP_TOKEN_NAME)
  }

  public setToken(token: string) {
    this.clearToken();
    this.decodedJwt = this.jwtHelper.decodeToken(token);
    if (this.isLaunchedEnrollee)
      sessionStorage.setItem(APP_TOKEN_NAME, token);
    else
      localStorage.setItem(APP_TOKEN_NAME, token);    
  }


  public clearToken() {  
      localStorage.removeItem(APP_TOKEN_NAME);
      sessionStorage.removeItem(APP_TOKEN_NAME);
  }

  public isAuthenticated(): boolean {
    // get the token
    const token = this.getToken();
    if (!token)
      return false;
    // return a boolean reflecting 
    // whether or not the token is expired
    return !this.jwtHelper.isTokenExpired(token);
  }

  public tokeExists(){
    return !!this.getToken();
  }


  private getClaimValue(claim) {
    if (!this.decodedJwt)
      this.decodedJwt = this.jwtHelper.decodeToken(this.getToken())
    return this.decodedJwt[claim];
  }

  public get isLaunchedEnrollee(): boolean {
    let claim = <string>this.getClaimValue('On_Behalf_of');
    return !!claim;
  }

  public isPasswordResetRequired() {
    if (!this.isAuthenticated())
      return null;
    let claim = <string>this.getClaimValue('Need_Password_Change');
    if (!claim)
      throw new Error('Need_Password_Change was not found');
    return claim.toLowerCase() == "true"
  }


}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts